exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".modal-alert{position:fixed;top:0;left:0;height:100%;width:100%;z-index:2;pointer-events:none;transition:opacity .3s;opacity:0;display:none;transform:translateZ(0)}.modal-alert.rendered{display:block}.modal-alert.visible{opacity:1;pointer-events:all}.modal-alert .black-bgr{position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,.75);z-index:1}.modal-alert .body{text-align:-webkit-center;position:fixed;top:5%;left:26.5%;height:30%;width:32%;z-index:2;background:#f1f1f1;padding:60px 90px;box-sizing:border-box;overflow:auto}.modal-alert .close{position:fixed;top:calc(5% + 30px);right:calc(12.5% + 40px);width:40px;height:40px;background-image:url(/assets/images/close-slim-black.png);background-repeat:no-repeat;background-position:50%;z-index:4}.modal-alert .close:hover{background-image:url(/assets/images/close-slim-hover.png)}/*!* ADAPTIVE *!*/@media (max-width:680px){.modal .body{width:100vw;height:calc(100vh - 60px);top:60px;left:0;transform:translate(0);padding:30px 10px}.modal .close{top:70px;right:20px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./app/shared/components/alert/alert.cmp.scss
// module id = 834
// module chunks = 1